@if (loadError) {
	<div class="flex min-h-[40vh] items-center justify-center px-6 py-12 text-sm text-gray-600">
		{{ loadError }}
	</div>
} @else if (feedbackTask && template) {
	<app-checklist-feedback
		[template]="template"
		[taskId]="feedbackTask.taskId"
		[submitted]="submitted"
		[embedded]="false"
		(back)="goBack()"
		(completed)="onCompleted()"
	></app-checklist-feedback>
} @else {
	<div class="flex min-h-[40vh] items-center justify-center px-6 py-12 text-sm text-gray-600">
		Loading feedback…
	</div>
}
